export const USERNAME_KEY = 'contact3DUsername';
export const REDIRECT_GAME_ID = 'contact3DRedirectGameId';
//# sourceMappingURL=LocalStorageKeys.js.map